/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';
import { mediaBreakpoints } from '../../../common/responsive';
import blend_letter_logo from './blend_letter_logo.png';
import { FooterLink } from './FooterLink';

export namespace PolicyLinks {
  export interface Props {}
}

const styles = StyleSheet.create({
  footerWrapper: {
    ...mixins.padding(24, 26, 24, 22),
    display: 'block',
    width: '100%',
    maxWidth: 1440,
    [mediaBreakpoints.mobile]: {
      width: 342,
      ...mixins.padding(0, 0, 16, 0),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [mediaBreakpoints.mobile]: {
      justifyContent: 'flex-start',
    },
  },
  logoWrapper: {
    display: 'flex',
    backgroundColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
    [mediaBreakpoints.mobile]: {
      paddingTop: 8,
    },
  },
  logo: {
    height: 28,
  },
  PolicyLinks: {
    display: 'flex',
    alignItems: 'center',
    [mediaBreakpoints.mobile]: {
      display: 'block',
      paddingLeft: 24,
      paddingTop: 4,
    },
  },
});

export const TERMS_OF_USE = 'TERMS_OF_USE';
export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const CONSENT_TO_ESIGN = 'CONSENT_TO_USE_ELECTRONIC_SIGNATURES_AND_RECORDS';

export const Footer: React.FC<PolicyLinks.Props> = ({}) => {
  return (
    <div className={css(styles.footerWrapper)} data-dd-privacy="allow">
      <div className={css(styles.wrapper)}>
        <div className={css(styles.logoWrapper)}>
          <img src={blend_letter_logo} className={css(styles.logo)} alt={'Blend Signing Room'} />
        </div>
        <div className={css(styles.PolicyLinks)}>
          <FooterLink textScreenId={TERMS_OF_USE} />
          <FooterLink textScreenId={PRIVACY_POLICY} />
          <FooterLink textScreenId={CONSENT_TO_ESIGN} />
        </div>
      </div>
    </div>
  );
};
